import $x from '@/utils/$x';

/**
 *
 * @param {*} params
 * @returns
 */
export function queryList(params) {
  return $x.post('/pergamonGoods/queryLittaGoodsInfoList', params);
}

export function deleteGood(params) {
  return $x.post('/pergamonGoods/deleteLittaGoodsInfo', params);
}

export function upAndDown(params) {
  return $x.post('/pergamonGoods/updateLittaGoodsStatus', params);
}
export function queryStockRuleList(params) {
  return $x.post('/pergamonGoodsStock/queryLittaGoodsStockList', params);
}

export function addStockRule(params) {
  return $x.post('/pergamonGoodsStock/saveLittaGoodsStock', params);
}

export function deleteStockRule(params) {
  return $x.post('/pergamonGoodsStock/deleteLittaGoodsStock', params);
}
export function updateStockRule(params) {
  return $x.post('/pergamonGoodsStock/updateLittaGoodsStock', params);
}
export function detailStockRule(params) {
  return $x.post('/pergamonGoodsStock/queryLittaGoodsStockById', params);
}

export function queryRightsExerciseType(params) {
  return $x.post('/pergamonGoods/queryRightsExerciseType', params);
}
